import React from 'react';
import { useHttpInterceptor } from '../api/interceptor';
import { Provider } from 'use-http';
import apiEndpoints from '../api/endpoints.constant';

const HttpProvider = ({ children }: { children: React.ReactNode }) => {
  const { options } = useHttpInterceptor();
  return (
    <Provider url={apiEndpoints.baseUrl} options={options}>
      {children}
    </Provider>
  );
};

export default HttpProvider;
